import {Link} from 'react-router-dom';
import React from 'react';
import {Icons} from '../assets/icons/Icons';
import {useAuthStore} from '../store';
import {getInitials} from '../utils';

export const Header = () => {
  const {user} = useAuthStore();
  return (
    // <div className="pt-4 py-2 w-[100px]" style={{ background: "#4a88db" }}>
    <div className="pt-4 py-2">
      <div className="page-title flex flex-row items-center justify-between py-2 px-4">
        <div
          className="align-self-center me-auto"
          style={{
            marginLeft: '10px',
          }}
        >
          <div>
            <Icons.Logo />
          </div>
        </div>
        {user && (
          <div className="flex flex-row items-center gap-x-[6.8px]">
            <div>
              <div
                data-bs-toggle="offcanvas"
                data-bs-target="#menu-notifications"
                style={{
                  marginTop: '3px',
                  cursor: 'pointer',
                  position: 'relative',
                }}
              >
                <Icons.NotificationBell />
                <div
                  style={{
                    height: 10,
                    width: 10,
                    backgroundColor: '#2E2CB2',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                  }}
                ></div>
              </div>
            </div>
            <Link to="/account" className="">
              {user?.avatar ? (
                <div className="icon gradient-blue shadow-bg shadow-bg-s rounded-m">
                  <Icons.UserAvatar />
                </div>
              ) : (
                <div className="w-[45px] h-[45px] rounded-full flex flex-row justify-center items-center bg-[#2B2A2F]">
                  <b className="text-lg text-white uppercase font-bold">
                    {getInitials(`${user?.firstname} ${user?.secondname}`)}
                  </b>
                </div>
              )}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
